import { Routes } from '@angular/router';

import {
  authRequiredChildGuard,
  authRequiredGuard,
  firstLaunchOnboardingGuard,
  onboardingPromptChildGuard,
} from './shared/guards/auth-required.guard';
import { statisticsVisibilityGuard } from './shared/guards/statistics-visibility.guard';

export const routes: Routes = [
  {
    path: 'verify-email/:key',
    loadComponent: () => import('./verify-email/verify-email.page').then((m) => m.VerifyEmailPage),
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./onboarding/onboarding.page').then((m) => m.OnboardingPage),
  },
  {
    path: '',
    loadComponent: () => import('./shared/components/mobile-shell/mobile-shell.component').then((m) => m.MobileShellComponent),
    children: [
      {
        path: 'register',
        loadComponent: () => import('./register/register.page').then((m) => m.RegisterPage),
      },
      {
        path: 'forgot-password',
        loadComponent: () => import('./forgot-password/forgot-password.page').then((m) => m.ForgotPasswordPage),
      },
      {
        path: 'reset-password/:uid/:token',
        loadComponent: () => import('./reset-password/reset-password.page').then((m) => m.ResetPasswordPage),
      },
      {
        path: 'login',
        loadComponent: () => import('./login/login.page').then((m) => m.LoginPage),
      },
      {
        path: 'privacy-policy',
        loadComponent: () => import('./legal/legal-page.component').then((m) => m.LegalPageComponent),
        data: { document: 'privacy' },
      },
      {
        path: 'terms-and-conditions',
        loadComponent: () => import('./legal/legal-page.component').then((m) => m.LegalPageComponent),
        data: { document: 'terms' },
      },
      {
        path: 'eula',
        loadComponent: () => import('./legal/legal-page.component').then((m) => m.LegalPageComponent),
        data: { document: 'eula' },
      },
      {
        path: '',
        canActivateChild: [onboardingPromptChildGuard],
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
          {
            path: 'home',
            canActivate: [firstLaunchOnboardingGuard],
            loadComponent: () => import('./home/home.page').then((m) => m.HomePage),
          },
          {
            path: 'discover',
            loadComponent: () => import('./discover/discover.page').then((m) => m.DiscoverPage),
          },
          {
            path: '',
            canActivateChild: [authRequiredChildGuard],
            children: [
              {
                path: 'panel',
                loadComponent: () => import('./dashboard/dashboard.page').then((m) => m.DashboardPage),
              },
              {
                path: 'estadisticas',
                canActivate: [statisticsVisibilityGuard],
                loadComponent: () => import('./statistics/statistics.page').then((m) => m.StatisticsPage),
              },
              {
                path: 'events/new',
                loadComponent: () => import('./event-create/event-create.page').then((m) => m.EventCreatePage),
              },
              {
                path: 'events/:id/edit',
                loadComponent: () => import('./event-create/event-create.page').then((m) => m.EventCreatePage),
              },
              {
                path: 'events/:id/estadisticas',
                canActivate: [statisticsVisibilityGuard],
                loadComponent: () => import('./statistics/statistics.page').then((m) => m.StatisticsPage),
              },
              {
                path: 'profile/edit',
                loadComponent: () => import('./profile-edit/profile-edit.page').then((m) => m.ProfileEditPage),
              },
              {
                path: 'yo',
                loadComponent: () => import('./mobile-yo/mobile-yo.page').then((m) => m.MobileYoPage),
              },
              {
                path: 'yo/settings',
                loadComponent: () => import('./mobile-settings/mobile-settings.page').then((m) => m.MobileSettingsPage),
              },
              {
                path: 'yo/edit',
                loadComponent: () => import('./mobile-profile-edit/mobile-profile-edit.page').then((m) => m.MobileProfileEditPage),
              },
              {
                path: 'yo/public-profile',
                loadComponent: () => import('./mobile-public-profile-edit/mobile-public-profile-edit.page').then((m) => m.MobilePublicProfileEditPage),
              },
              {
                path: 'yo/account-type',
                loadComponent: () => import('./mobile-account-type/mobile-account-type.page').then((m) => m.MobileAccountTypePage),
              },
              {
                path: 'yo/notifications',
                loadComponent: () => import('./mobile-notifications/mobile-notifications.page').then((m) => m.MobileNotificationsPage),
              },
              {
                path: 'yo/zones',
                loadComponent: () => import('./mobile-zones/mobile-zones.page').then((m) => m.MobileZonesPage),
              },
              {
                path: 'messages/:conversationId',
                loadComponent: () => import('./messages/messages.page').then((m) => m.MessagesPage),
              },
              {
                path: 'messages',
                loadComponent: () => import('./messages/messages.page').then((m) => m.MessagesPage),
              },
            ],
          },
          {
            path: 'events/:id',
            loadComponent: () => import('./event/event.page').then((m) => m.EventPage),
          },
          {
            path: 'giggers',
            loadComponent: () => import('./giggers/giggers.page').then((m) => m.GiggersPage),
          },
          {
            path: 'giggers/:id',
            loadComponent: () => import('./profile/profile.page').then((m) => m.ProfilePage),
            data: {
              profileKind: 'gigger',
            },
          },
          {
            path: 'gigplaces',
            loadComponent: () => import('./gigplaces/gigplaces.page').then((m) => m.GigplacesPage),
          },
          {
            path: 'gigplaces/:id',
            loadComponent: () => import('./profile/profile.page').then((m) => m.ProfilePage),
            data: {
              profileKind: 'gigplace',
            },
          },
          {
            path: 'musicians/:id',
            loadComponent: () => import('./profile/profile.page').then((m) => m.ProfilePage),
            data: {
              profileKind: 'musician',
            },
          },
          {
            path: 'app-movil',
            loadComponent: () => import('./mobile-app/mobile-app.page').then((m) => m.MobileAppPage),
          },
          {
            path: 'quienes-somos',
            loadComponent: () => import('./about/about.page').then((m) => m.AboutPage),
          },
          {
            path: '**',
            redirectTo: 'home',
          },
        ],
      },
    ],
  },
];
